import VisualMatchingView from "@features/tools/view/visual-matching-view/visual-matching-view";

const VisualMatching = () => {
  return <VisualMatchingView />;
};

export default VisualMatching;
